import { AUTH_TOKEN, ROLE_TOKEN, REFRESH_TOKEN, AUTH_USER_INFO, AUTH_USER_BALANCE, AUTH_USER } from "constant/constant";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import errorIcon from "../../assets/images/modal/alert.svg";
import { API_SECURITY_KEY, BASE_URL } from "constant/apiService";
import { cookie } from "utils/cookie/index";
import axios from "axios/index";
import { Modal } from "antd";
import React from "react";
import { get as _get, has, isEmpty, startsWith } from "lodash";

const secretKey = API_SECURITY_KEY || false;
const keyBytes = secretKey ? new Uint8Array(secretKey.match(/.{1,2}/g).map(byte => parseInt(byte, 16))) : "";

async function encryptData(data) {
  try {
    const key = await window.crypto.subtle.importKey("raw", keyBytes, "AES-GCM", false, ["encrypt"]);
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    let dataToEncode;
    if (typeof data === "string") {
      dataToEncode = data;
    } else {
      dataToEncode = JSON.stringify(data);
    }

    const encodedData = new TextEncoder().encode(dataToEncode);
    const encryptedBuffer = await window.crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encodedData);
    const ed = window.btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
    const ivBase64 = window.btoa(String.fromCharCode(...iv));
    return { ed, iv: ivBase64 };
  } catch (error) {
    console.error("Encryption Error:", error);
    return data;
  }
}

const removeEmptyQueryStrings = url => {
  try {
    const urlObj = new URL(BASE_URL + url);
    [...urlObj.searchParams].forEach(([key, value]) => {
      if (isEmpty(value) || value == "undefined") urlObj.searchParams.delete(key);
    });
    return urlObj.href.replace(BASE_URL, "").toString();
  } catch (error) {
    console.log(error);
    return url;
  }
};

async function encryptUrl(urlPath, params = "") {
  if (/[?&]data=.*[?&]iv=/.test(urlPath)) return `${BASE_URL}${urlPath}`;

  const queryString = new URLSearchParams(params).toString();
  const path = `${urlPath}?${queryString}`;
  const combinedString = removeEmptyQueryStrings(path);
  const encryptedParams = await encryptData(combinedString);
  return `${BASE_URL}?data=${encodeURIComponent(encryptedParams.ed)}&iv=${encodeURIComponent(encryptedParams.iv)}`;
}

const base64ToUint8Array = base64 => {
  const paddedBase64 = base64
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
  const decodedData = atob(paddedBase64);
  const uint8Array = new Uint8Array(decodedData.length);
  for (let i = 0; i < decodedData.length; i++) {
    uint8Array[i] = decodedData.charCodeAt(i);
  }
  return uint8Array;
};

async function decryptResponse(data) {
  if (!data || !data.ed || !data.iv || !data.authTag) {
    throw new Error("Missing encryptedData, iv, or authTag in response");
  }
  const { ed, iv, authTag } = data;
  const cryptoKey = await window.crypto.subtle.importKey("raw", keyBytes, "AES-GCM", false, ["decrypt"]);
  const ivBuffer = base64ToUint8Array(iv);
  const encryptedBuffer = base64ToUint8Array(ed);
  const authTagBuffer = base64ToUint8Array(authTag);
  const completeEncryptedBuffer = new Uint8Array(encryptedBuffer.length + authTagBuffer.length);
  completeEncryptedBuffer.set(encryptedBuffer);
  completeEncryptedBuffer.set(authTagBuffer, encryptedBuffer.length);
  const decryptedBuffer = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: ivBuffer,
      tagLength: 128
    },
    cryptoKey,
    completeEncryptedBuffer
  );
  const decryptedText = new TextDecoder().decode(decryptedBuffer);
  try {
    return JSON.parse(decryptedText);
  } catch (error) {
    return decryptedText;
  }
}

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

const authHeader = () => {
  const token = cookie.get(AUTH_TOKEN);
  const roletoken = sessionStorage.getItem(ROLE_TOKEN);
  return { Authorization: `Bearer ${token}`, roletoken };
};

const getHeaders = auth => {
  let headers = { ...defaultHeaders };
  // if (auth) {
  //   headers = { ...headers, ...authHeader() };
  // }
  return headers;
};

const url = (path, params) => {
  const sections = path.split(":");
  const sectionsWithParams = sections.map(section => (startsWith(section, "/") ? section : params[section]));
  const pathWithParams = sectionsWithParams.join("");
  return BASE_URL + pathWithParams;
};

export const buildQueryParamsURL = (url, params = {}) => {
  if (!params || Object.keys(params).length === 0) return url;

  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  return queryString ? `${url}${url.includes("?") ? "&" : "?"}${queryString}` : url;
};

const apiService = axios.create({ withCredentials: true });

// Function that will be called to refresh authorization
const refreshAuthLogic = async failedRequest => {
  cookie.clearAll();
  window.location.href = "/";
  // const url = secretKey ? await encryptUrl(`/auth/accessToken`) : `${BASE_URL}/auth/accessToken`;
  // const data = await encryptData({
  //   accessToken: cookie.get(AUTH_TOKEN),
  //   refreshToken: cookie.get(REFRESH_TOKEN)
  // });
  // return axios
  //   .post(url, data, { headers: { withCredentials: true } })
  //   .then(async ({ data: res }) => {
  //     let data = res;
  //     if (data && data?.ed && data?.iv && secretKey) {
  //       data = await decryptResponse(data);
  //     }

  //     if (data?.data?.accessToken) {
  //       if (!secretKey) {
  //         cookie.set(AUTH_TOKEN, data.data.accessToken);
  //         const newToken = `Bearer ${data.data.accessToken}`;
  //         failedRequest.response.config.headers["Authorization"] = newToken;
  //       }
  //       //apiService.defaults.headers["Authorization"] = newToken;
  //       return Promise.resolve();
  //     } else {
  //       console.log(error);
  //       cookie.clearAll();
  //       window.location.href = "/";
  //       throw Error("Access token not found");
  //     }
  //   })
  //   .catch(error => {
  //     console.log(error);
  //     cookie.clearAll();
  //     window.location.href = "/";
  //     return Promise.resolve();
  //   });
};

createAuthRefreshInterceptor(apiService, refreshAuthLogic, {
  statusCodes: [401]
});

export const get = (path, params = {}, auth = true, headers = {}) => apiService.get(url(path, params), { params });

export const post = (path, params = {}, auth = true) => apiService.post(url(path, params), params);

export const put = (path, params = {}, auth = true) => apiService.put(url(path, params), params);

export const deleteRequest = (path, params = {}, data = {}) => apiService.delete(url(path, params), { params, data });

apiService.interceptors.request.use(async request => {
  if (secretKey) {
    request.url = await encryptUrl(request.url.replace(BASE_URL, ""), request.params);
    request.params = {};
  }
  if (secretKey && ["post", "put", "delete"].includes(request.method) && request.data) {
    if (request.data instanceof FormData) {
      const encryptedData = await encryptFormData(request.data);
      request.data = encryptedData;
      request.headers["Content-Type"] = "multipart/form-data";
    } else {
      const encryptedData = await encryptData(request.data);
      request.data = encryptedData;
    }
  }
  return request;
});

apiService.interceptors.response.use(
  async function(response) {
    if (response.data && response.data?.ed && response.data?.iv && secretKey) {
      response.data = await decryptResponse(response.data);
    }
    if (has(response.data, "success") && !_get(response.data, "success")) {
      function countDown() {
        let secondsToGo = 5;
        const modal = Modal.warning({
          title: <span className="fw-bold text-center fs-5">Error Occured</span>,
          content: <span className="text-center">{response.data.message}</span>,
          icon: (
            <img
              src={errorIcon}
              style={{
                margin: "0 auto 10px",
                width: "100%",
                height: "50px"
              }}
            />
          ),
          centered: true,
          zIndex: 1031,
          okButtonProps: {
            className: "px-4"
          }
        });
        setTimeout(() => {
          clearInterval();
          modal.destroy();
        }, secondsToGo * 1000);
      }
      countDown();
      // message.error(response.data.message);
      //GAEvent("error", "apiError", "fail", response.data.message, false);
      if (!response.data.message.startsWith("Bad")) {
        return Promise.reject(_get(response.data, "message"));
      }
    } else if (has(response.data, "status") && !_get(response.data, "status")) {
      const persist = response.data?.error?.schedule === "legacy_unsupported";
      function countDown() {
        let secondsToGo = 5;
        const modal = Modal.warning({
          title: <span className="fw-bold text-center fs-5">Error Occured</span>,
          content: <span className="text-center">{response.data.message}</span>,
          icon: (
            <img
              src={errorIcon}
              style={{
                margin: "0 auto 10px",
                width: "100%",
                height: "50px"
              }}
            />
          ),
          centered: true,
          zIndex: 1031,
          closable: persist,
          maskClosable: persist,
          okButtonProps: {
            className: "px-4"
          }
        });
        if (!persist) {
          setTimeout(() => {
            clearInterval();
            modal.destroy();
          }, secondsToGo * 1000);
        }
      }
      countDown();
      // message.error(response.data.message, 8);
    }
    return response;
  },
  function(error) {
    if (error.response && error.response.data && error.response.data.message) {
      //GAEvent("error", "apiError", "fail", error.response.data.message, false);
      if (!error.response.data.message.startsWith("Bad")) {
        function countDown() {
          let secondsToGo = 5;
          const modal = Modal.warning({
            title: <span className="fw-bold text-center fs-5">Error Occured</span>,
            content: <span className="text-center">{error.response.data.message}</span>,
            icon: (
              <img
                src={errorIcon}
                style={{
                  margin: "0 auto 10px",
                  width: "100%",
                  height: "50px"
                }}
              />
            ),
            centered: true,
            zIndex: 1031,
            okButtonProps: {
              className: "px-4"
            }
          });
          setTimeout(() => {
            clearInterval();
            modal.destroy();
          }, secondsToGo * 1000);
        }
        countDown();
        // message.error(error.response.data.message);
        if (error.response.data.message === "Email already exists, Please login") {
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(error.response);
  }
);

async function encryptFormData(formData) {
  const otherFields = {};
  for (const [key, value] of Array.from(formData.entries())) {
    if (!(value instanceof File || value instanceof Blob)) {
      otherFields[key] = value;
      formData.delete(key);
    }
  }

  let encrypted = null;
  if (Object.keys(otherFields).length > 0) {
    encrypted = await encryptData(otherFields);
  }

  if (encrypted) {
    formData.append("data", encrypted.ed);
    formData.append("iv", encrypted.iv);
  }
  return formData;
}
